import { cn } from "@/utils/cn";

const DEFAULT_TOTAL_SEGMENTS = 9;

interface OnboardingSegmentedProgressProps {
  filled: number;
  total?: number;
  className?: string;
}

/** Segmented progress bar of the dark v5 onboarding top nav. */
export const OnboardingSegmentedProgress = ({
  filled,
  total = DEFAULT_TOTAL_SEGMENTS,
  className,
}: OnboardingSegmentedProgressProps) => (
  <div className={cn("flex h-1 w-full overflow-hidden rounded-[2px]", className)}>
    {Array.from({ length: total }, (_, i) => (
      <div key={i} className={cn("h-full flex-1", i < filled ? "bg-[#bc9cf2]" : "bg-[#0c1a38]")} />
    ))}
  </div>
);
